import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/src/layouts/default.vue").then(m => m.default || m)),
  linktree: defineAsyncComponent(() => import("/vercel/path0/src/layouts/linktree.vue").then(m => m.default || m))
}